module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av390-ecbd6e342df5be2938c27d70f109ec91.jpg";